export enum AclRoleReference {
  ProjectManager = 'project_member',
  WorkspaceAdmin = 'workspace_admin',
}
